import styled from "styled-components";
import { ReactComponent as PhoneIconLink } from "../../SvgIcons/phone.svg";
import { ReactComponent as MailIconLink } from "../../SvgIcons/mail.svg";
import { ReactComponent as PinIconLink } from "../../SvgIcons/pin.svg";
import { ReactComponent as TourIconLink } from "../../SvgIcons/360.svg";
import { ReactComponent as BookingIconLink } from "../../SvgIcons/booking.svg";
import { ReactComponent as StatuteIconLink } from "../../SvgIcons/statute.svg";

export const AddressSection = styled.section`
  padding: 40px 40px 0;

  @media (max-width: 768px) {
     padding: 20px 20px;
  }
`;

export const AddressHeader = styled.h2`
    font-size: 48px;
    text-align: center;
    margin-top: 0;
    
    @media (max-width: 768px) {
        font-size: 32px;
}
`;

export const AddressSubHeader = styled.h3`
    font-size: 24px;
    margin-top: 0;
        @media (max-width: 768px) {
        font-size: 18px;
}
`;

export const AddressInfo = styled.address`
    font-style: normal;
    max-width: 420px;
`;

export const LinkWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 14px 0;
`;

export const AddressLink = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    width: fit-content;

    font-size: 20px;
    font-weight: bold;
    line-height: 1.3;
    text-decoration: none;
    transition: transform 0.2s ease, color 0.2s ease;
    color: #93a981;

    &:hover {
        color: hsla(93, 30%, 67%, 1);
        transform: translateY(-1px);
    }

    svg {
        flex-shrink: 0;
    }

    @media (max-width: 768px) {
        font-size: 17px;
    }
`;

export const LinkDescription = styled.span`
    display: block;
    margin-top: 3px;
    margin-left: 29px;

    font-size: 16px;
    font-weight: 400;
    line-height: 1.4;
    color: #171717;

    @media (max-width: 768px) {
        margin-left: 22px;
        font-size: 15px;
    }
`;

export const Info = styled.p`
    font-size: 18px;
    font-weight: 400;
    max-width: 670px;
    line-height: 1.4;

    @media (max-width: 768px) {
    font-size: 16px;
}
`;

export const IconsWrapper = styled.div`
    display: flex;
    gap: 24px;
    margin-top: 24px;

    @media (max-width: 768px) {
        margin: 18px 0;
        gap: 16px;
}
`;

export const AddressContentWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 40px;
    align-items: start;

    @media (max-width: 1100px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 20px;
    }
`;

export const PhoneIcon = styled(PhoneIconLink)`
    width: 24px;
    height: 24px;
    transition: color 0.3s;

        @media (max-width: 768px) {
          width: 17px;
          height: 17px;
}
`;

export const TourIcon = styled(TourIconLink)`
    width: 24px;
    height: 24px;
    transition: color 0.3s;

        @media (max-width: 768px) {
          width: 17px;
          height: 17px;
}
`;

export const MailIcon = styled(MailIconLink)`
    width: 24px;
    height: 24px;
    transition: color 0.3s;

        @media (max-width: 768px) {
          width: 17px;
          height: 17px;
}
  `;

export const PinIcon = styled(PinIconLink)`
    width: 24px;
    height: 24px;
    transition: color 0.3s;

      @media (max-width: 768px) {
          width: 17px;
          height: 17px;
}
`;

export const BookingIcon = styled(BookingIconLink)`
    width: 24px;
    height: 24px;
    transition: color 0.3s;

      @media (max-width: 768px) {
          width: 17px;
          height: 17px;
}
`;

export const StatuteIcon = styled(StatuteIconLink)`
    width: 24px;
    height: 24px;
    transition: color 0.3s;

      @media (max-width: 768px) {
          width: 17px;
          height: 17px;
}
`;